import { useMutation } from "@tanstack/react-query";
import { axiosInstance } from "../../utils/axiosInstance";
import { message } from "antd";
import { queryClient } from "services/queryClient";

export const useMarkAsPickedUp = () => {
  return useMutation({
    mutationFn: (id: any) =>
      axiosInstance
        .post(`orders/${id}/drivers/mark-as-picked-up`)
        .then((res: any) => res.data),
    onSuccess: async (data: any) => {
      queryClient.invalidateQueries({ queryKey: ["useGetDriverOrdersQuery"] });
    },
    onError: (error: any) => {
      message.error(error?.response?.data?.message);
    },
  });
};
